var render = function render(){var _vm=this,_c=_vm._self._c;return _c('detail',{attrs:{"id":_vm.id,"verify":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }